import React from 'react';
import FilterSVG from '../../svgComponents/FilterSVG';
import { getComputedCSSVariable } from '../../../utils/cssVariableHelpers';

import ButtonDropDown from './filters/ButtonDropDown';

interface Option {
  label: string,
  value: string,
}

interface Props {
  actions: Array<Option>,
  setBulkAction: (action: Option) => void,
  bulkAction?: Option,
}
const BulkSelectorMenu: React.FC<Props> = ({
  actions,
  setBulkAction,
  bulkAction,
}) => {
  if (bulkAction) {
    return (
      <ButtonDropDown
        options={actions}
        hideSearch={true}
        setValue={setBulkAction}
        value={bulkAction}
        buttonLabel="Bulk Actions"
        Icon={<FilterSVG color={getComputedCSSVariable('white')} />}
      />
    );
  }
  return <></>;
};

export default BulkSelectorMenu;
